import { ServerConfig } from '../../model/ServerConfig';
import { ApplicationActions, ApplicationActionTypes } from './ApplicationActions';

export interface ApplicationState {
  config: ServerConfig;
}

export const initialState: ApplicationState = {
  config: null
};

export function applicationReducer(state: ApplicationState = initialState, action: ApplicationActions): ApplicationState {
  switch (action.type) {
    case ApplicationActionTypes.InitApplicationConfig: {
      return {
        ...state,
        config: action.payload
      };
    }
  }
  return state;
}

export const initApplicationConfig = (state: ApplicationState) => state.config;
